/* STEP 2 · agent s2q5 — Q5: Founder → Maintenance, the target of a script that runs over every firm (firm picker, include
   deleted engagements) and the platform-only label. EN + AR. Loaded from lib/i18n/ by the generated index (STEP 2 · B2). */
export const I18N_S2Q5 = {
  en: {
    s2q5: {
      runsOn: "Runs on",
      everyFirm: "Every firm (each in its own database)",
      oneFirm: "{name} only",
      platformDb: "Platform database",
      firmPickerTitle: "Pick one firm to run it for that firm only",
      includeDeleted: "Include deleted engagements",
      includeDeletedHint: "Engagements in the recycle bin are skipped unless this is ticked.",
      globalHint: "Scripts that run over every firm have their own firm choice in their row.",
    },
  },
  ar: {
    s2q5: {
      runsOn: "يعمل على",
      everyFirm: "كل شركة (كلٌّ في قاعدة بياناتها الخاصة)",
      oneFirm: "{name} فقط",
      platformDb: "قاعدة بيانات المنصة",
      firmPickerTitle: "اختر شركة واحدة لتشغيله لتلك الشركة فقط",
      includeDeleted: "تضمين الارتباطات المحذوفة",
      includeDeletedHint: "تُتخطّى الارتباطات الموجودة في سلة المحذوفات ما لم يُحدَّد هذا الخيار.",
      globalHint: "النصوص التي تعمل على كل شركة لها اختيار الشركة في صفّها.",
    },
  },
};

export default I18N_S2Q5;
